import { AUTH_CONFIG } from "../configs/auth.config";
import { ApiUrl } from "../configs/path.config";
import { ENVIRONMENT } from "../constants/constants";
import NetworkService from "../services/networkService";
import { getEnvironment } from "../utils";
import { appConstants } from "../../common/constants/constants";

async function getTokenId(authCode, logintype) {
  const ENV = getEnvironment();
  let REDIRECT_URI =
    logintype === appConstants.Internal
      ? AUTH_CONFIG.REDIRECT_URI_LOCAL
      : AUTH_CONFIG.EXT_REDIRECT_URI_LOCAL;
  if (ENV === ENVIRONMENT.PROD) {
    REDIRECT_URI =
      logintype === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_PROD
        : AUTH_CONFIG.EXT_REDIRECT_URI_PROD;
  } else if (ENV === ENVIRONMENT.QA) {
    REDIRECT_URI =
      logintype === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_QA
        : AUTH_CONFIG.EXT_REDIRECT_URI_QA;
  } else if (ENV === ENVIRONMENT.DEV) {
    REDIRECT_URI =
      logintype === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_DEV
        : AUTH_CONFIG.EXT_REDIRECT_URI_DEV;
  }

  let clientid =
    logintype === appConstants.Internal
      ? AUTH_CONFIG.CLIENT_ID
      : AUTH_CONFIG.EXT_CLIENT_ID;
  let clientSecret =
    logintype === appConstants.Internal
      ? AUTH_CONFIG.CLIENT_SECRET
      : AUTH_CONFIG.EXT_CLIENT_SECRET;
  // PKCE: retrieve code_verifier from sessionStorage
  let code_verifier =
    logintype === appConstants.External
      ? sessionStorage.getItem("pkce_code_verifier")
      : logintype === appConstants.Internal
        ? sessionStorage.getItem("pkce_code_verifier")
        : undefined;

  // Build token request data
  let loginData =
    "grant_type=" +
    AUTH_CONFIG.GRANT_TYPE +
    "&code=" +
    authCode +
    "&client_id=" +
    clientid +
    "&redirect_uri=" +
    REDIRECT_URI +
    "&code_verifier=" +
    code_verifier;

  // Note: state parameter is validated in callback, not sent in token request
  // Some OAuth providers may require it - uncomment if needed:
  // const state = sessionStorage.getItem("oauth_state");
  // if (state) {
  //   loginData += "&state=" + state;
  // }

  return await NetworkService.postData(ApiUrl.getAuthTokenURL(), loginData, {
    contentType: "application/x-www-form-urlencoded",
  });
}

export { getTokenId };
